import FormInputField from "frontend/ui-components/form-fields/form-input-field";
import style from "./invite-to-account-emails.module.css";
import CloseCircledIcon from "frontend/icons/close-circled";
import { FIRST_EMAIL_ID } from "./invite-to-account-utils";
import { InviteToAccountErrorType } from "./types";

export interface EmailInputProps {
  id: string;
  value: string;
  disabled: boolean;
  onChange: (value: string) => void;
  onKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  onFocus?: (id: string) => void;
  isValidEmail: (email: string) => { isValid: boolean; errorType: InviteToAccountErrorType };
}

export default function EmailInput({
  id,
  value,
  disabled,
  onChange,
  onKeyDown,
  onFocus,
  isValidEmail,
}: EmailInputProps) {
  const { isValid, errorType } = isValidEmail(value);

  return (
    <FormInputField
      autoFocus={id === FIRST_EMAIL_ID}
      value={value}
      id={id}
      key={id}
      placeholder="Add email here"
      onChange={onChange}
      autoComplete="auto-complete-off"
      disabled={disabled}
      className={style.emailInputContainer}
      inputClassName={style.emailInput}
      onKeyDown={onKeyDown}
      onFocus={onFocus}
      customErrorMessageComponent={
        !!value && !isValid ? (
          <div className={style.customErrorMessageContainer}>
            <CloseCircledIcon />{" "}
            {errorType === InviteToAccountErrorType.SameUserEmail
              ? "You’re in! Invite your teammates"
              : "Invalid email"}
          </div>
        ) : null
      }
    />
  );
}
